import {createRootContextHook} from 'common/util/react';

export const useMetrics = createRootContextHook(`metrics`);
